import { fetchMethod, postMethod } from "./http.api";

const MessageService = {

    getCarMessage: async (carId: string) => {
        return await fetchMethod(`/v1/Messaging/car/${carId}/loggedinuser/messages`);
    },

    getReportMessage: async (reportId: string) => {
        return await fetchMethod(`/v1/Messaging/loggedinuser/messages?SummaryReportId=${reportId}`);
    },

    addCarMessage: async (requestData: object) => {
        return postMethod("/v1/Messaging", requestData);
    }
};

export default MessageService;